/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withMagicApronTNT } from '@thd-olt-component-middleware/pip';

import { AugmentedReality as AugmentedRealitySSR } from '@thd-olt-component-react/augmented-reality?clientSideRemove';

import { ConsumerCardMessaging as ConsumerCardMessagingSSR } from '@thd-olt-component-react/consumer-card-messaging?clientSideRemove';

import { AisleBay as AisleBaySSR } from '@thd-olt-component-react/aisle-bay?clientSideRemove';

import { SuperSku as SuperSkuSSR } from '@thd-olt-component-react/super-sku?clientSideRemove';

import { OrderSample as OrderSampleSSR } from '@thd-olt-component-react/order-sample?clientSideRemove';

import { GlobalCustomConfigurator as GlobalCustomConfiguratorSSR } from '@thd-olt-component-react/global-custom-configurator?clientSideRemove';

import { ReturnsMessaging as ReturnsMessagingSSR } from '@thd-olt-component-react/returns-messaging?clientSideRemove';

import { BotPrompt as BotPromptSSR } from '@thd-olt-component-react/magic-apron?clientSideRemove';

import { ProductOverviewAccordionBody as ProductOverviewAccordionBodySSR } from '@thd-olt-component-react/product-overview?clientSideRemove';

import { SpecificationsWithKPFAccordionBody as SpecificationsWithKPFAccordionBodySSR } from '@thd-olt-component-react/specifications?clientSideRemove';

import { QuestionsAndAnswersAccordionBody as QuestionsAndAnswersAccordionBodySSR } from '@thd-olt-component-react/questions-and-answers?clientSideRemove';

import { RatingsAndReviewsAccordionBody as RatingsAndReviewsAccordionBodySSR } from '@thd-olt-component-react/ratings-and-reviews?clientSideRemove';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleSlotF6Index0K0Header }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleSlotF6Index1K0Header }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleSlotF6Index2K0Header }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleSlotF6Index3K0Header }
from '@thd-olt-component-react/ratings-and-reviews';

const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
};

const SlotD6Placeholder0 = null;

const SlotD6Index0Client = () => {
  return import(
    '@thd-olt-component-react/augmented-reality');
};

export const SlotD6Index0Load = withDynamicImport({
  server: () => {
    return AugmentedRealitySSR;
  },
  client: SlotD6Index0Client,
  placeholder: SlotD6Placeholder0 || getPlaceholder({ skip: true }),
  name: 'AugmentedReality',
});

lazySlots.LazySlotD6 = withLayout(

  [

    SlotD6Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotD6Index0Client,
      placeholder: SlotD6Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const PLCCAbovePlaceholder0 = null;

const PLCCAboveIndex0Client = () => {
  return import(
    '@thd-olt-component-react/consumer-card-messaging');
};

export const PLCCAboveIndex0Load = withDynamicImport({
  server: () => {
    return ConsumerCardMessagingSSR;
  },
  client: PLCCAboveIndex0Client,
  placeholder: PLCCAbovePlaceholder0 || getPlaceholder({ skip: true }),
  name: 'ConsumerCardMessaging',
});

lazySlots.LazyPLCCAbove = withLayout(

  [

    PLCCAboveIndex0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: PLCCAboveIndex0Client,
      placeholder: PLCCAbovePlaceholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE7Placeholder0 = null;

const SlotE7Index0Client = () => {
  return import(
    '@thd-olt-component-react/aisle-bay');
};

export const SlotE7Index0Load = withDynamicImport({
  server: () => {
    return AisleBaySSR;
  },
  client: SlotE7Index0Client,
  placeholder: SlotE7Placeholder0 || getPlaceholder({ skip: true }),
  name: 'AisleBay',
});

lazySlots.LazySlotE7 = withLayout(

  [

    SlotE7Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE7Index0Client,
      placeholder: SlotE7Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE8Placeholder0 = null;

const SlotE8Index0Client = () => {
  return import(
    '@thd-olt-component-react/super-sku');
};

export const SlotE8Index0Load = withDynamicImport({
  server: () => {
    return SuperSkuSSR;
  },
  client: SlotE8Index0Client,
  placeholder: SlotE8Placeholder0 || getPlaceholder({ skip: true }),
  name: 'SuperSku',
});

lazySlots.LazySlotE8 = withLayout(

  [

    SlotE8Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE8Index0Client,
      placeholder: SlotE8Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE9Placeholder0 = null;

const SlotE9Index0Client = () => {
  return import(
    '@thd-olt-component-react/order-sample');
};

export const SlotE9Index0Load = withDynamicImport({
  server: () => {
    return OrderSampleSSR;
  },
  client: SlotE9Index0Client,
  placeholder: SlotE9Placeholder0 || getPlaceholder({ skip: true }),
  name: 'OrderSample',
});

lazySlots.LazySlotE9 = withLayout(

  [

    SlotE9Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE9Index0Client,
      placeholder: SlotE9Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE10Placeholder0 = null;

const SlotE10Index0Client = () => {
  return import(
    '@thd-olt-component-react/global-custom-configurator');
};

export const SlotE10Index0Load = withDynamicImport({
  server: () => {
    return GlobalCustomConfiguratorSSR;
  },
  client: SlotE10Index0Client,
  placeholder: SlotE10Placeholder0 || getPlaceholder({ skip: true }),
  name: 'GlobalCustomConfigurator',
});

lazySlots.LazySlotE10 = withLayout(

  [

    SlotE10Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE10Index0Client,
      placeholder: SlotE10Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotE12Placeholder0 = null;

const SlotE12Index0Client = () => {
  return import(
    '@thd-olt-component-react/returns-messaging');
};

export const SlotE12Index0Load = withDynamicImport({
  server: () => {
    return ReturnsMessagingSSR;
  },
  client: SlotE12Index0Client,
  placeholder: SlotE12Placeholder0 || getPlaceholder({ skip: true }),
  name: 'ReturnsMessaging',
});

lazySlots.LazySlotE12 = withLayout(

  [

    SlotE12Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotE12Index0Client,
      placeholder: SlotE12Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF5Placeholder0 = null;

const SlotF5Index0Client = () => {
  return import(
    '@thd-olt-component-react/magic-apron');
};

export const SlotF5Index0Load = withDynamicImport({
  server: () => {
    return BotPromptSSR;
  },
  client: SlotF5Index0Client,
  placeholder: SlotF5Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_SlotF5 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_SlotF5 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_SlotF5, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'above-accordion' } });

lazySlots.LazySlotF5 = withLayout(

  [

    SlotF5Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_SlotF5
  ,

  [

    {
      waitForComponent: SlotF5Index0Client,
      placeholder: SlotF5Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotF6Placeholder0K0 = null;

const SlotF6Index0ClientK0 = () => {
  return import(
    '@thd-olt-component-react/product-overview');
};

export const SlotF6Index0LoadK0 = withDynamicImport({
  server: () => {
    return ProductOverviewAccordionBodySSR;
  },
  client: SlotF6Index0ClientK0,
  placeholder: SlotF6Placeholder0K0 || getPlaceholder({ skip: true }),
  name: 'ProductOverviewAccordionBody',
});

lazySlots.LazySlotF6KBody1 = withLayout(
  SlotF6Index0LoadK0,

  null
  ,
  {
    waitForComponent: SlotF6Index0ClientK0,
    placeholder: SlotF6Placeholder0K0 || getPlaceholder({ skip: true })
  }
);

const SlotF6Placeholder1K0 = null;

const SlotF6Index1ClientK0 = () => {
  return import(
    '@thd-olt-component-react/specifications');
};

export const SlotF6Index1LoadK0 = withDynamicImport({
  server: () => {
    return SpecificationsWithKPFAccordionBodySSR;
  },
  client: SlotF6Index1ClientK0,
  placeholder: SlotF6Placeholder1K0 || getPlaceholder({ skip: true }),
  name: 'SpecificationsWithKPFAccordionBody',
});

lazySlots.LazySlotF6KBody2 = withLayout(
  SlotF6Index1LoadK0,

  null
  ,
  {
    waitForComponent: SlotF6Index1ClientK0,
    placeholder: SlotF6Placeholder1K0 || getPlaceholder({ skip: true })
  }
);

const SlotF6Placeholder2K0 = null;

const SlotF6Index2ClientK0 = () => {
  return import(
    '@thd-olt-component-react/questions-and-answers');
};

export const SlotF6Index2LoadK0 = withDynamicImport({
  server: () => {
    return QuestionsAndAnswersAccordionBodySSR;
  },
  client: SlotF6Index2ClientK0,
  placeholder: SlotF6Placeholder2K0 || getPlaceholder({ skip: true }),
  name: 'QuestionsAndAnswersAccordionBody',
});

lazySlots.LazySlotF6KBody3 = withLayout(
  SlotF6Index2LoadK0,

  null
  ,
  {
    waitForComponent: SlotF6Index2ClientK0,
    placeholder: SlotF6Placeholder2K0 || getPlaceholder({ skip: true })
  }
);

const SlotF6Placeholder3K0 = null;

const SlotF6Index3ClientK0 = () => {
  return import(
    '@thd-olt-component-react/ratings-and-reviews');
};

export const SlotF6Index3LoadK0 = withDynamicImport({
  server: () => {
    return RatingsAndReviewsAccordionBodySSR;
  },
  client: SlotF6Index3ClientK0,
  placeholder: SlotF6Placeholder3K0 || getPlaceholder({ skip: true }),
  name: 'RatingsAndReviewsAccordionBody',
});

lazySlots.LazySlotF6KBody4 = withLayout(
  SlotF6Index3LoadK0,

  null
  ,
  {
    waitForComponent: SlotF6Index3ClientK0,
    placeholder: SlotF6Placeholder3K0 || getPlaceholder({ skip: true })
  }
);

const LazySlotF6Accordion = withLayoutAccordion([
  [

    [

      withLayout(
        ProductOverviewAccordionTitleSlotF6Index0K0Header,

      ),

    ],

    [

      withLayout(
        SpecificationsAccordionTitleSlotF6Index1K0Header,

      ),

    ],

    [

      withLayout(
        QuestionsAndAnswersAccordionTitleSlotF6Index2K0Header,

      ),

    ],

    [

      withLayout(
        RatingsAndReviewsAccordionTitleSlotF6Index3K0Header,

      ),

    ],

  ],
  [

    [

      lazySlots.LazySlotF6KBody1,

    ],

    [

      lazySlots.LazySlotF6KBody2,

    ],

    [

      lazySlots.LazySlotF6KBody3,

    ],

    [

      lazySlots.LazySlotF6KBody4,

    ],

  ]
],

null
);

const SlotF7Placeholder0 = null;

const SlotF7Index0Client = () => {
  return import(
    '@thd-olt-component-react/magic-apron');
};

export const SlotF7Index0Load = withDynamicImport({
  server: () => {
    return BotPromptSSR;
  },
  client: SlotF7Index0Client,
  placeholder: SlotF7Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_SlotF7 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_SlotF7 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_SlotF7, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'default', default: true } });

lazySlots.LazySlotF7 = withLayout(

  [

    SlotF7Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_SlotF7
  ,

  [

    {
      waitForComponent: SlotF7Index0Client,
      placeholder: SlotF7Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
  components.forEach((com, index) => {
    // eslint-disable-next-line no-param-reassign
    com.props = hydratedProps[index];
  });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  const ssr = typeof window === 'undefined';
  const decisionIndex = ssr
    ? 0
    : Number(
      (window.__SLOT_DECISIONS__ && window.__SLOT_DECISIONS__[props.slot]) ?? '0'
    );

  if (props.slot === 'SlotD6') {

    return (
      <lazySlots.LazySlotD6
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotD6"
        fusionComponentName="@thd-olt-component-react/augmented-reality"
        version="7.5.1"
      />
    );

  }

  if (props.slot === 'PLCCAbove') {

    return (
      <lazySlots.LazyPLCCAbove
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="PLCCAbove"
        fusionComponentName="@thd-olt-component-react/consumer-card-messaging"
        version="9.10.2"
      />
    );

  }

  if (props.slot === 'SlotE7') {

    return (
      <lazySlots.LazySlotE7
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotE7"
        fusionComponentName="@thd-olt-component-react/aisle-bay"
        version="7.13.1"
      />
    );

  }

  if (props.slot === 'SlotE8') {

    return (
      <lazySlots.LazySlotE8
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotE8"
        fusionComponentName="@thd-olt-component-react/super-sku"
        version="13.35.0"
      />
    );

  }

  if (props.slot === 'SlotE9') {

    return (
      <lazySlots.LazySlotE9
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotE9"
        fusionComponentName="@thd-olt-component-react/order-sample"
        version="5.15.4"
      />
    );

  }

  if (props.slot === 'SlotE10') {

    return (
      <lazySlots.LazySlotE10
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotE10"
        fusionComponentName="@thd-olt-component-react/global-custom-configurator"
        version="2.6.0"
      />
    );

  }

  if (props.slot === 'SlotE12') {

    return (
      <lazySlots.LazySlotE12
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotE12"
        fusionComponentName="@thd-olt-component-react/returns-messaging"
        version="1.16.0"
      />
    );

  }

  if (props.slot === 'SlotF5') {

    return (
      <lazySlots.LazySlotF5
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotF5"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="8.6.0"
      />
    );

  }

  if (props.slot === 'SlotF6') {

    return (
      <LazySlotF6Accordion
        {...props}
        config={props.config}
        fusionSlotName="SlotF6"
        fusionComponentName="accordion"
        fusionClassName={slot.fusionClassName}
        isDynamic
        // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
        // queryProvider={{
        //   inherit: 'page',
        //   merge,
        //   queryOptions,
        //   cache key for all accordions must be the same
        //   otherwise a race condition will occur generating duplicate requests
        //   cacheKey: 'page',
        //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
        // }}
      />
    );

  }

  if (props.slot === 'SlotF7') {

    return (
      <lazySlots.LazySlotF7
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="SlotF7"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="8.6.0"
      />
    );

  }

  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};